/**
 * a11y dialog
 */

(function($) {

  // a11y dialog
  var dialogEl = document.getElementById('contact-form-dialog');

  if (dialogEl) {
    var mainEl = document.querySelector('main');
    var dialog = new A11yDialog(dialogEl, mainEl);

    /*dialog.on('show', function (dialogEl, triggerEl) {
      console.log(dialogEl);
      console.log(triggerEl);
    })*/
  }

  // show dialog based on link anchor
  $('a[href*=\\#]').on('click', function (e) {

    var url = this.href;
    // anchor values to trigger show dialog on link button click
    var anchors = ['lomake', 'form'];

    // show dialog if url contains any array value
    $(anchors).each(function() {
      if(url.includes(this)) {
        e.preventDefault();
        dialog.show();
      }
    });

  });

})(jQuery);
